<template>
  <div
    class="fixed-top tw-transition-transform tw-duration-300"
    :class="isHeaderVisible ? 'tw-translate-y-2' : '-tw-translate-y-full'"
    style="z-index: 1031"
  >
    <!-- TODO: Create a specific component for the dropdown menu -->
    <div class="container d-flex justify-content-end">
      <div
        v-if="!hidePartners"
        class="nav-item dropdown hover-dropdown lg:tw-pl-0 tw-pl-5 tw-content-center"
      >
        <a
          class="nav-link mobile-dropdown-toggle"
          style="color: #5f5f61"
          href="#"
          role="button"
          @click.prevent="emit('toggle-dropdown', $event)"
        >
          Partners
          <i class="mobile-arrow ms-2"></i>
        </a>
        <div class="dropdown-menu custom-mega-menu multi-column showblocks">
          <!-- Header row (icons + titles) -->
          <div class="mega-menu-header">
            <div class="column-header tw-mr-[20px]">
              <img
                src="/img/svgs/partners-icon.svg"
                alt="icon"
                class="column-icon"
              /><span class="column-title">Join Our Network</span>
            </div>
          </div>
          <hr class="mega-divider" />
          <!-- Link groups row -->
          <div class="mega-menu-inner">
            <div class="mega-column tw-grid">
              <ul class="column-links">
                <li class="tw-h-fit">
                  <a
                    href="/partners"
                    class="dropdown-item"
                    >Become a Partner</a
                  >
                </li>
                <li class="tw-h-fit">
                  <a
                    href="/affiliate"
                    class="dropdown-item"
                    >Affiliate</a
                  >
                </li>
                <li class="tw-h-fit">
                  <a
                    href="/ib"
                    class="dropdown-item"
                    >IB</a
                  >
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <!-- <LayoutLanguageSelector
        @toggle-dropdown="emit('toggle-dropdown', $event)"
      /> -->
    </div>
  </div>
</template>

<script lang="ts" setup>
defineProps({
  isHeaderVisible: {
    type: Boolean,
    default: false,
  },
  hidePartners: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['toggle-dropdown']);
</script>

<style lang="scss" scoped>
.custom-mega-menu {
  background: white !important;
  color: black !important;
  border-radius: 20px !important;
  padding: 15px !important;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
}

.mega-menu-header {
  display: flex;
}

.column-header {
  display: flex;
  align-items: center;
  font-weight: bold;
  font-size: 18px;
  color: #000;
  flex: 1;
  padding-bottom: 10px;
}

.column-icon {
  width: 18px;
  height: 18px;
  margin-right: 10px;
}

.mega-divider {
  border: none;
  border-top: 2px solid #d1d1d1;
  margin: 0 0 10px 0;
}

.mega-menu-inner {
  display: flex;
}

.mega-column {
  flex: 1;
  min-width: 180px;
}

.column-links {
  list-style: none;
  padding: 0;
  margin: 0;
}
.markets-dropdown {
  display: grid;
  grid-template-columns: 100px 30px;
}
.column-title {
  font-size: 14px;
}

.column-links .dropdown-item {
  padding: 4px 0;
  color: #000;
  font-size: 13px;
  text-decoration: none;
  &:hover {
    color: var(--bs-primary);
  }
}

.mobile-navigation-item {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  margin: 0 auto 10px auto;
  padding-top: 10px;
  width: fit-content;
  background: transparent;
}

.nav-link {
  font-weight: 500;
  padding: 0.75rem 1rem !important;
  transition: all 0.3s ease;
}

.nav-link:hover {
  color: #ffffff !important;
  background-color: rgba(255, 255, 255, 0.1);
  border-radius: 6px;
}
</style>
